export default "__VITE_ASSET__DXFIrFgZ__"